import {
  CoreCarsComponent,
  HIGHLIGHTED_CAR_SPECS,
  useCarsStyles,
} from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import type { Vehicle } from "@b2bportal/ground-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./CarSpecificationsSummary.module.scss";

interface CarSpecificationsSummaryProps extends PlatformComponentProps {
  vehicle: Vehicle;
}

const COMPONENT_KEY = CoreCarsComponent.CarSpecificationsSummary;
export function CarSpecificationsSummary({
  className,
  vehicle,
}: CarSpecificationsSummaryProps) {
  const { t } = useI18nContext();
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  return (
    <div className={clsx(block, className)}>
      {HIGHLIGHTED_CAR_SPECS.filter(
        (item) => item.getText(t, vehicle) != null
      ).map((specification) => {
        return (
          <div key={specification.key} className={cn("specification")}>
            <Icon className={cn("icon")} iconName={specification.iconName} />
            <span>{specification.getText(t, vehicle)}</span>
          </div>
        );
      })}
    </div>
  );
}
